const queues = {
	title: "Kø",
	id: "ID",
	queue: "Oppgave kø",
	payload: "Oppgave",
	attempts: "Forsøk",
	reserved_at: "Reservert",
	available_at: "Tilgjengelig",
	created_at: "Opprettet",
};
export default queues;